const lsg_header = { 
    init: () => {
        

        const headerEls     = document.querySelectorAll(`.lsg-header-shy`),
              cartCountEls  = document.querySelectorAll(`[lsg-cart-count]`),
              thresholdShy  = 500;
        

        // Cart AJAX Listener
        // This needs work. Reponse from ATC doesn't provide cart item count.
        (function(ns, fetch) {
            if (typeof fetch !== 'function') return;
            ns.fetch = function() {
                const response = fetch.apply(this, arguments);
                response.then(res => {
                    if ([
                            `${window.location.origin}/cart.js`,
                            `${window.location.origin}/cart/add.js`,
                            `${window.location.origin}/cart/update.js`,
                            `${window.location.origin}/cart/change.js`,
                            `${window.location.origin}/cart/clear.js`,
                        ].includes(res.url)) {
                        res.clone().json().then(data => {
                            if (typeof data.item_count !== 'undefined') {
                                cartCountEls.forEach((cartCountEl) => {
                                    cartCountEl.textContent = data.item_count;
                                });
                            } else {
                                // console.log(data);
                            }
                        });
                    }
                });
                return response;
            }
        }(window, window.fetch));
        fetch(`${window.location.origin}/cart.js`);
        


        headerEls.forEach((headerEl) => {
            const parentEl      = headerEl.parentElement,
                  headerHeight  = headerEl.offsetHeight;

            parentEl.addEventListener(`mouseenter`, (e) => {
                headerEl.style.transform = `translateY(0)`;
            });

            function throttle(fn, wait) {
                var time = Date.now();
                return function() {
                    if ((time + wait - Date.now()) < 0) {
                        fn();
                        time = Date.now();
                    }
                }
            }

            let scrollOld   = window.scrollY;

            window.addEventListener('scroll', throttle(function() {
                let scrollNew = window.scrollY;

                if (scrollNew > scrollOld && scrollNew > thresholdShy) {
                    // Shy
                    headerEl.style.transform = `translateY(${headerHeight * -1}px)`;
                } else {
                    // Show
                    headerEl.style.transform = `translateY(0)`;
                }

                scrollOld = window.scrollY;
            }, 10));
        });


    }
}
export default lsg_header;